import { render, staticRenderFns } from "./MyProfile.vue?vue&type=template&id=39707661&scoped=true&"
import script from "./MyProfile.vue?vue&type=script&lang=js&"
export * from "./MyProfile.vue?vue&type=script&lang=js&"
import style0 from "./MyProfile.vue?vue&type=style&index=0&id=39707661&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39707661",
  null
  
)

export default component.exports